<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
        <div class="title" >
            <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
            <div class="md-body-1">Loading ...</div>
        </div>
    </md-content>
    <div class="background"/>
  </div>
</template>

<script>
import * as types from '../store/event_types'
import Cookies from 'js-cookie'

export default {
    name: "Callback",
    data() {
        return {
          state: Cookies.get('state')
        }
    },
    methods: {
        next(){
            this.$store.dispatch(types.VERIFY_AUTHENTICATION, { 'hash': location.hash, 'state': this.state})
        }
    },
    mounted () {
        this.next()
    }
}
</script>
